import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { setCookie, getCookie } from 'helpers/Storage';
import { isNationEntitled } from 'helpers/ConfigHelper';
import { setFreemiumModalVisibilityAction as setFreemiumModalVisibility } from './AppActions';

export const FreemiumContext = createContext({
  isFreemium: false,
  freemiumThreshold: 0,
  hasAccount: false,
  setFreemiumModalVisibility: () => {},
});
export const FREEMIUM_EXPERIENCE = 'freemium';

let freemiumCookie = null;
let isFreemium = false;
let freemiumThreshold = 0;

const FreemiumContextProvider = ({
  children,
  hasAccount,
  isAuthenticated,
  isHomePage,
  isNation,
  isNationLicensed,
  isSeriesDetailPage,
  isWatchPage,
  setFreemiumModalVisibility,
  seriesId,
}) => {
  const SetValuesThroughOptimizely = () => {
    const [isEnabled, variables, clientReady] = useState(false, {}, false);
    const { video_count_threshold: threshold = 0 } = variables;
    if (isEnabled && clientReady) {
      isFreemium = isWatchPage ? !isNationLicensed && isEnabled : isEnabled;
      _.set(window, 'utag_data.isFreemium', isFreemium);
      freemiumThreshold = threshold;
      freemiumCookie = threshold;
      setCookie({ name: FREEMIUM_EXPERIENCE, value: threshold, options: { path: '/' } });
    } else if (clientReady) {
      freemiumCookie = false;
    }
  };

  // This follow the logic of freemium flow chart refer to
  // https://fng-jira.fox.com/browse/CPEWEB-1582
  if (isNation && (isWatchPage || isHomePage || isSeriesDetailPage) && !isNationEntitled()) {
    if (isSeriesDetailPage || isWatchPage) {
      isFreemium = !isNationLicensed && isFreemium;
    } else if (isHomePage && freemiumCookie) {
      isFreemium = true;
    } else if (isHomePage && freemiumCookie === false) {
      SetValuesThroughOptimizely();
    }
    if (freemiumCookie === null) {
      const freemiumCookieThreshold = getCookie({ name: FREEMIUM_EXPERIENCE });
      if (freemiumCookieThreshold) {
        if (isWatchPage) {
          SetValuesThroughOptimizely();
        } else if (isHomePage || isSeriesDetailPage) {
          isFreemium = true;
          freemiumThreshold = parseInt(freemiumCookieThreshold, 10);
          freemiumCookie = freemiumCookieThreshold;
        }
      } else if (isWatchPage) {
        isFreemium = false;
        freemiumThreshold = 0;
        freemiumCookie = false;
      } else if (isHomePage || isSeriesDetailPage) {
        SetValuesThroughOptimizely();
      }
    }
    if ((isSeriesDetailPage || isWatchPage) && !seriesId) {
      freemiumCookie = null;
    }
  }

  const contextValue = {
    isFreemium,
    hasAccount,
    freemiumThreshold,
    setFreemiumModalVisibility,
    // isAuthenticated is coming as true only in case user is logged in with MVPD
    hasAccountOrProvider: isAuthenticated || hasAccount,
  };

  return <FreemiumContext.Provider value={contextValue}>{children}</FreemiumContext.Provider>;
};

const mapStateToProps = ({ app: { account } }) => ({
  hasAccount: !!account,
});

FreemiumContextProvider.defaultProps = {
  hasAccount: false,
  isAuthenticated: false,
  isHomePage: false,
  isNation: false,
  isNationLicensed: false,
  isSeriesDetailPage: false,
  isWatchPage: false,
  seriesId: '',
  setFreemiumModalVisibility: () => {},
};

FreemiumContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  hasAccount: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isHomePage: PropTypes.bool,
  isNation: PropTypes.bool,
  isNationLicensed: PropTypes.bool,
  isSeriesDetailPage: PropTypes.bool,
  isWatchPage: PropTypes.bool,
  seriesId: PropTypes.string,
  setFreemiumModalVisibility: PropTypes.func,
};
export default connect(mapStateToProps, { setFreemiumModalVisibility })(FreemiumContextProvider);
